<div
  class="ops-sort-menu-button"
  [class.expanded]="isExpanded === 1"
  [class.collapsed]="isExpanded === 2"
>
  <button type="button" class="sort-button" (click)="toggleSort()">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
    >
      <path
        d="M19.833 16.333L13.9997 11.6663L8.16634 16.333"
        stroke="#747EFA"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <span>{{ 'labels.sortBy' | translate }}</span>
  </button>

  <div class="sort-options-wrapper">
    <div class="sort-options-container">
      @for (sortItem of sortOptions; track sortItem.name) {
      <div
        (click)="toggleSortOption(sortItem.id)"
        [class]="sortOptionClass(sortItem)"
      >
        <svg
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path
              d="M12 20L9.40193 14.4L14.5981 14.4L12 20Z"
              fill="#747EFA"
            ></path>
            <path d="M12 4L14.5981 9.6L9.40192 9.6L12 4Z" fill="#747EFA"></path>
          </g>
        </svg>
        <span>{{ sortItem.name }}</span>
      </div>
      }
    </div>
  </div>
</div>
